import type { DataItemId } from '@pn/core/domain/data';
import { safeMap } from '@pn/core/utils/logic';
import { apiListMapper } from '@pn/services/api/list/apiListMapper';
import { pnApiClient } from '@pn/services/api/pnApiClient';
import type { ApiList } from './types';

const getListWorkspaceItems = async () => {
  const apiLists = await pnApiClient.request<ApiList[]>({
    url: 'v2/lists',
  });

  const workspaceItems = safeMap(apiLists, apiListMapper.toWorkspaceItem);

  return workspaceItems;
};

const getListWorkspaceItemById = async (listId: string) => {
  const apiList = await pnApiClient.request<ApiList>({
    url: `v2/lists/${listId}`,
  });

  const workspaceItem = apiListMapper.toWorkspaceItem(apiList);

  return workspaceItem;
};

const convertListToStack = async (listId: string, ids: DataItemId[]) => {
  const { stack_project_id } = await pnApiClient.request<{
    stack_project_id: string;
  }>({
    method: 'POST',
    url: `v2/lists/${listId}/stack`,
    payload: { ids },
  });

  return stack_project_id;
};

export const apiListProvider = {
  getListWorkspaceItems,
  getListWorkspaceItemById,
  convertListToStack,
};
